/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { CostExcludingTaxesResource } from './';
import {
    CostExcludingTaxesResourceFromJSON,
    CostExcludingTaxesResourceFromJSONTyped,
    CostExcludingTaxesResourceToJSON,
} from './';
import type { FreelancerClientLegalEntityResource } from './';
import {
    FreelancerClientLegalEntityResourceFromJSON,
    FreelancerClientLegalEntityResourceFromJSONTyped,
    FreelancerClientLegalEntityResourceToJSON,
} from './';
import type { WorkforceContractModel } from './';
import {
    WorkforceContractModelFromJSON,
    WorkforceContractModelFromJSONTyped,
    WorkforceContractModelToJSON,
} from './';
import type { WorkforceProjectManagerResource } from './';
import {
    WorkforceProjectManagerResourceFromJSON,
    WorkforceProjectManagerResourceFromJSONTyped,
    WorkforceProjectManagerResourceToJSON,
} from './';
import type { WorkforceProjectStatus } from './';
import {
    WorkforceProjectStatusFromJSON,
    WorkforceProjectStatusFromJSONTyped,
    WorkforceProjectStatusToJSON,
} from './';
import type { WorkingStatus } from './';
import {
    WorkingStatusFromJSON,
    WorkingStatusFromJSONTyped,
    WorkingStatusToJSON,
} from './';

/**
 * 
 * @export
 * @interface WorkforceProjectResource
 */
export interface WorkforceProjectResource {
    /**
     * Raw project ID (FE hook for deep-link in iteration 2)
     * @type {string}
     * @memberof WorkforceProjectResource
     */
    confirmedProjectId: string;
    /**
     * Project title (contract subject)
     * @type {string}
     * @memberof WorkforceProjectResource
     */
    name?: string;
    /**
     * 
     * @type {WorkingStatus}
     * @memberof WorkforceProjectResource
     */
    workMode?: WorkingStatus;
    /**
     * 
     * @type {WorkforceProjectManagerResource}
     * @memberof WorkforceProjectResource
     */
    projectManager?: WorkforceProjectManagerResource;
    /**
     * 
     * @type {FreelancerClientLegalEntityResource}
     * @memberof WorkforceProjectResource
     */
    clientLegalEntity: FreelancerClientLegalEntityResource;
    /**
     * ISO 3166-1 alpha-2 country code of the client legal entity
     * @type {string}
     * @memberof WorkforceProjectResource
     */
    location?: string;
    /**
     * 
     * @type {WorkforceContractModel}
     * @memberof WorkforceProjectResource
     */
    contractModel: WorkforceContractModel;
    /**
     * 
     * @type {Date}
     * @memberof WorkforceProjectResource
     */
    projectStartDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof WorkforceProjectResource
     */
    projectEndDate?: Date;
    /**
     * Days worked; only populated for COST_PLUS rows
     * @type {number}
     * @memberof WorkforceProjectResource
     */
    daysInvoiced?: number;
    /**
     * 
     * @type {CostExcludingTaxesResource}
     * @memberof WorkforceProjectResource
     */
    costExcludingTaxes?: CostExcludingTaxesResource;
    /**
     * 
     * @type {WorkforceProjectStatus}
     * @memberof WorkforceProjectResource
     */
    status: WorkforceProjectStatus;
}

/**
 * Check if a given object implements the WorkforceProjectResource interface.
 */
export function instanceOfWorkforceProjectResource(value: object): value is WorkforceProjectResource {
    if (!('confirmedProjectId' in value) || value['confirmedProjectId'] === undefined) return false;
    if (!('clientLegalEntity' in value) || value['clientLegalEntity'] === undefined) return false;
    if (!('contractModel' in value) || value['contractModel'] === undefined) return false;
    if (!('projectStartDate' in value) || value['projectStartDate'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function WorkforceProjectResourceFromJSON(json: any): WorkforceProjectResource {
    return WorkforceProjectResourceFromJSONTyped(json, false);
}

export function WorkforceProjectResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkforceProjectResource {
    if (json == null) {
        return json;
    }
    return {
        
        'confirmedProjectId': json['confirmedProjectId'],
        'name': json['name'] == null ? undefined : json['name'],
        'workMode': json['workMode'] == null ? undefined : WorkingStatusFromJSON(json['workMode']),
        'projectManager': json['projectManager'] == null ? undefined : WorkforceProjectManagerResourceFromJSON(json['projectManager']),
        'clientLegalEntity': FreelancerClientLegalEntityResourceFromJSON(json['clientLegalEntity']),
        'location': json['location'] == null ? undefined : json['location'],
        'contractModel': WorkforceContractModelFromJSON(json['contractModel']),
        'projectStartDate': (new Date(json['projectStartDate'])),
        'projectEndDate': json['projectEndDate'] == null ? undefined : (new Date(json['projectEndDate'])),
        'daysInvoiced': json['daysInvoiced'] == null ? undefined : json['daysInvoiced'],
        'costExcludingTaxes': json['costExcludingTaxes'] == null ? undefined : CostExcludingTaxesResourceFromJSON(json['costExcludingTaxes']),
        'status': WorkforceProjectStatusFromJSON(json['status']),
    };
}

export function WorkforceProjectResourceToJSON(value?: WorkforceProjectResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'confirmedProjectId': value['confirmedProjectId'],
        'name': value['name'],
        'workMode': WorkingStatusToJSON(value['workMode']),
        'projectManager': WorkforceProjectManagerResourceToJSON(value['projectManager']),
        'clientLegalEntity': FreelancerClientLegalEntityResourceToJSON(value['clientLegalEntity']),
        'location': value['location'],
        'contractModel': WorkforceContractModelToJSON(value['contractModel']),
        'projectStartDate': ((value['projectStartDate']).toISOString().substring(0,10)),
        'projectEndDate': value['projectEndDate'] == null ? undefined : ((value['projectEndDate'] as any).toISOString().substring(0,10)),
        'daysInvoiced': value['daysInvoiced'],
        'costExcludingTaxes': CostExcludingTaxesResourceToJSON(value['costExcludingTaxes']),
        'status': WorkforceProjectStatusToJSON(value['status']),
    };
}

